/*
  File: italiansecret-review-toast.js

  Purpose:
  Review toast notification logic with auto-hide and dismiss TTL.
*/

(function () {
  const toast = document.querySelector('[data-is-tp-toast]');
  if (!toast) return;

  const tsvUrl = toast.getAttribute('data-tsv-url');
  const delaySeconds = Number(toast.getAttribute('data-delay-seconds')) || 0;
  const displaySeconds = Number(toast.getAttribute('data-display-seconds')) || 6;
  const reviewsPerCycle = Number(toast.getAttribute('data-reviews-per-cycle')) || 1;
  const repeatSeconds = Number(toast.getAttribute('data-repeat-seconds')) || 0;
  const dismissDays = Number(toast.getAttribute('data-dismiss-days')) || 7;
  const showStars = toast.getAttribute('data-show-stars') !== 'false';
  const showReviewLink = toast.getAttribute('data-show-review-link') !== 'false';

  const closeBtn = toast.querySelector('[data-is-tp-toast-close]');
  const linkEl = toast.querySelector('[data-is-tp-toast-link]');
  const starsEl = toast.querySelector('[data-is-tp-toast-stars]');
  const authorEl = toast.querySelector('[data-is-tp-toast-author]');
  const headlineEl = toast.querySelector('[data-is-tp-toast-headline]');
  const bodyEl = toast.querySelector('[data-is-tp-toast-body]');

  const DISMISS_KEY = 'italiansecret_review_toast_dismiss_until';

  let reviews = [];
  let showTimer = null;
  let hideTimer = null;
  let cycleTimer = null;

  function sanitize(str) {
    return String(str || '')
      .replace(/\r?\n+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseTSV(text) {
    const lines = text.split('\n').filter(l => l.trim());
    if (lines.length <= 1) return [];

    return lines.slice(1).map(line => {
      const c = line.split('\t');
      return {
        reviewUrl: sanitize(c[1]),
        authorName: sanitize(c[2]),
        rating: Number(c[3]) || 0,
        headline: sanitize(c[4]),
        reviewText: sanitize(c[5])
      };
    }).filter(r => r.reviewText && r.reviewUrl);
  }

  function starsString(rating) {
    return '★★★★★'.slice(0, Math.max(0, Math.min(5, rating)));
  }

  function isDismissed() {
    try {
      const until = Number(localStorage.getItem(DISMISS_KEY) || 0);
      return until && Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  function setDismissed() {
    try {
      const until = Date.now() + dismissDays * 24 * 60 * 60 * 1000;
      localStorage.setItem(DISMISS_KEY, String(until));
    } catch (e) {}
  }

  function renderReview(review) {
    if (!linkEl || !starsEl || !authorEl || !headlineEl || !bodyEl) return;
    if (showReviewLink) {
      linkEl.href = review.reviewUrl;
      linkEl.target = '_blank';
      linkEl.rel = 'noopener';
      linkEl.classList.remove('is-tp-toast__card--nolink');
    } else {
      linkEl.removeAttribute('href');
      linkEl.removeAttribute('target');
      linkEl.removeAttribute('rel');
      linkEl.classList.add('is-tp-toast__card--nolink');
    }

    if (showStars) {
      starsEl.textContent = starsString(review.rating);
      starsEl.style.display = '';
    } else {
      starsEl.textContent = '';
      starsEl.style.display = 'none';
    }
    authorEl.textContent = review.authorName;
    headlineEl.textContent = review.headline;
    bodyEl.textContent = review.reviewText;
  }

  function showToast() {
    if (isDismissed() || !reviews.length) return;
    const pick = reviews[Math.floor(Math.random() * reviews.length)];
    renderReview(pick);
    toast.classList.add('is-tp-toast--visible');

    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      toast.classList.remove('is-tp-toast--visible');
    }, displaySeconds * 1000);
  }

  function showSequence(index) {
    if (isDismissed() || !reviews.length) return;
    const pick = reviews[Math.floor(Math.random() * reviews.length)];
    renderReview(pick);
    toast.classList.add('is-tp-toast--visible');

    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      if (index + 1 < reviewsPerCycle) {
        showSequence(index + 1);
        return;
      }
      toast.classList.remove('is-tp-toast--visible');
      if (repeatSeconds > 0) {
        cycleTimer = setTimeout(() => showSequence(0), repeatSeconds * 1000);
      }
    }, displaySeconds * 1000);
  }

  function startCycle() {
    clearTimeout(showTimer);
    clearTimeout(cycleTimer);

    showTimer = setTimeout(() => {
      if (reviewsPerCycle > 1) {
        showSequence(0);
      } else {
        showToast();
        if (repeatSeconds > 0) {
          cycleTimer = setInterval(showToast, repeatSeconds * 1000);
        }
      }
    }, delaySeconds * 1000);
  }

  function stopCycle() {
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    clearTimeout(cycleTimer);
  }

  function updateOffset() {
    const bar = document.querySelector('.is-sticky-cart-bar');
    const base = 18;
    let offset = base;

    if (bar && !bar.hasAttribute('hidden')) {
      const rect = bar.getBoundingClientRect();
      offset = rect.height + base;
    }

    toast.style.bottom = offset + 'px';
  }

  function observeStickyBar() {
    const bar = document.querySelector('.is-sticky-cart-bar');
    if (!bar) return;

    const observer = new MutationObserver(updateOffset);
    observer.observe(bar, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
  }

  async function init() {
    if (!tsvUrl || isDismissed()) return;

    try {
      const res = await fetch(tsvUrl, { cache: 'no-store' });
      const text = await res.text();
      reviews = parseTSV(text);
    } catch (e) {
      reviews = [];
    }

    if (!reviews.length) return;

    updateOffset();
    observeStickyBar();
    window.addEventListener('resize', updateOffset);

    startCycle();
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      stopCycle();
      toast.classList.remove('is-tp-toast--visible');
      setDismissed();
    });
  }

  init();
})();
